import { BatchDetailsState } from '../initial.state';
import { BatchManagementActions } from '../actions/batch.action';

function BatchManagemntReducer(state = new BatchDetailsState(), action) {
  switch (action.type) {
    case BatchManagementActions.BATCH_LIST_SUCCESS:
      return {
        ...state,
        batchList: action.payload,
      };
    case BatchManagementActions.BATCH_DETAILS_SUCCESS:
      return {
        ...state,
        batchDetails: action.payload.data,
      };
    case BatchManagementActions.ADD_NEW_BATCH_SUCCESS:
      return {
        ...state,
        createUpdateOrCloseBatchSuccess: true,
      };
    case BatchManagementActions.UPDATE_BATCH_SUCCESS:
      return {
        ...state,
        createUpdateOrCloseBatchSuccess: true,
      };
    case BatchManagementActions.CLOSE_BATCH_SUCCESS:
      return {
        ...state,
        createUpdateOrCloseBatchSuccess: true,
      };
    case BatchManagementActions.BRANCH_LIST_SUCCESS:
      return {
        ...state,
        branchList: action.payload.data,
      };
    case BatchManagementActions.ADD_NEW_BRANCH_SUCCESS:
      return {
        ...state,
      };
    case BatchManagementActions.ADD_NEW_PROGRAM_SUCCESS:
      return {
        ...state,
      };
    case BatchManagementActions.PROGRAM_LIST_SUCCESS:
      return {
        ...state,
        programList: action.payload,
      };
    case BatchManagementActions.RESET_CREATE_BATCH_SUCCESS:
      return {
        ...state,
        createUpdateOrCloseBatchSuccess: false,
      };
    case BatchManagementActions.UPLOAD_STUDENTS_SUCCESS:
      return {
        ...state,
        uploadStudentsSuccess: true,
      };
    case BatchManagementActions.STUDENTS_LIST_SUCCESS:
      return {
        ...state,
        studentsList: action.payload.data,
      };
    case BatchManagementActions.UPDATE_BATCH_OF_STUDENTS:
      return {
        ...state,
        updateBatchStudentSuccess: true,
      };
    case BatchManagementActions.ADD_NEW_GROUP_SUCCESS:
      return {
        ...state,
        createGroupSuccess: true,
      };
    case BatchManagementActions.GROUP_LIST_SUCCESS:
      return {
        ...state,
        groupList: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}

export { BatchManagemntReducer };
